import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, App, LoadingController, ModalController, NavController } from 'ionic-angular';
import { SessionProvider } from '../../../../../providers/session/session';
import { ValueProvider } from '../../../../../providers/value/value';
import { MysportUserProfilePage } from '../../../../me/mysport/mysport-user-profile/mysport-user-profile';
import { ParticipantPage } from '../../../../participant-page/participant-page';
import { TeamSettingsModal } from '../../../../team-settings-modal/team-settings-modal';
import { LineUpService, ToolbarType } from '../../../lineup/services/lineup-service';
import { TournamentService } from '../../services/tournament.service';

@Component({
  selector: 'gamer-teams',
  templateUrl: 'gamer-teams.html',
})
export class GamerTeamsPage {
  activePlan: number = 0;
  reloader: boolean = true;

  constructor(
    private app: App,
    public ls: LineUpService,
    private modalCtrl: ModalController,
    private actionCtrl: ActionSheetController,
    public gs: TournamentService,
    private sessionService: SessionProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private valueService: ValueProvider
  ) {  }

  ionViewWillEnter(){
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.gs.getPlanList().then(t => {
      loader.dismiss();
      this.reload();
    }).catch(e => {
      loader.dismiss();
    });
  }

  onEdit(team: any) {
    (this.app.getRootNav() as NavController).push(ParticipantPage, { team: team })
  }

  onRemoveTeam(i: number) {
    let sheet = this.actionCtrl.create({
      title: this.translate.instant('MYSPORT_PHOTOS_SHEET_TITLE'),
      buttons: [
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
          role: 'destructive',
          handler: () => {
            this.gs.planList[this.activePlan].teams.splice(i, 1);
            this.gs.save();
          }
        },
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    sheet.present();
  }

  openTeamSettings() {
    let modal = this.modalCtrl.create(TeamSettingsModal);
    modal.present();
  }

  onTeamNameChange(){
    this.gs.saveTeam(this.gs.planList[this.activePlan]);
  }

  onPlayersClick(activeTeam: number) {
    this.app.getRootNav().getActiveChildNav().select(3);
    this.ls.changeMenuSub.next({
      type: ToolbarType.tshirt,
      activeTeam: activeTeam,
      activePlan: this.activePlan
    });
  }
  
  onTeamDown(team: any, i: number) {
    let t = this.gs.planList[this.activePlan].teams[i + 1].ord;
    this.gs.planList[this.activePlan].teams[i + 1].ord = team.ord;
    this.gs.planList[this.activePlan].teams[i].ord = t;
    this.save();
    Promise.all([
      this.gs.saveTeam(this.gs.planList[this.activePlan].teams[i + 1]),
      this.gs.saveTeam(this.gs.planList[this.activePlan].teams[i])
    ]).then(() => {
      this.reload();
    });
  }

  sortByOrder(){
    return this.gs.planList[this.activePlan].teams.sort((a,b) => a.ord - b.ord);
  }

  onTeamUp(team: any, i: number) {
    let t = this.gs.planList[this.activePlan].teams[i - 1].ord;
    this.gs.planList[this.activePlan].teams[i - 1].ord = team.ord;
    this.gs.planList[this.activePlan].teams[i].ord = t;
    this.save();
    Promise.all([
      this.gs.saveTeam(this.gs.planList[this.activePlan].teams[i - 1]),
      this.gs.saveTeam(this.gs.planList[this.activePlan].teams[i])
    ]).then(() => {
      this.reload();
    });
  }

  reload(){
    this.reloader = false;
    setTimeout(() => {
      this.reloader = true;
    });
  }

  save(){
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => this.gs.planList[this.activePlan] = plan);
    this.gs.save();
  }

  onActivePlanChange() {
    console.log(this.activePlan);
  }

  onAddPlan() {
    this.app.getRootNav().getActiveChildNav().select(1);
  }

  showLogin(){
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });

    this.valueService.getProfileBackgrounds().then(backgrounds => {
      (this.app.getRootNav() as NavController)
        .push(MysportUserProfilePage, {
          data: { profile: this.sessionService.profile, backgrounds: backgrounds }
        })
    });
  }

  onOpenSettings(){
    // this.app.getRootNav().push(TeamSettingsModal);
    this.sessionService.getTokenAndNavigate().then(token => {
      const modal = this.modalCtrl.create(TeamSettingsModal);
      modal.onDidDismiss(option => {
        console.log('option',option)
      })
      modal.present();
    });
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

}





// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/team-list/gamer-teams.ts